import { values } from "lodash";
import { useHistory, useLocation, useParams } from "react-router-dom";

import { WorkOpportunitiesTab } from "../../constants/work_opportunities_tab";

export const useWorkOpportunitiesTab = (): WorkOpportunitiesTab | null => {
  const { tab } = useParams<{ tab: WorkOpportunitiesTab }>();
  const history = useHistory();
  const { pathname } = useLocation();

  if (!pathname.startsWith("/marketplace/work_opportunities")) {
    return null;
  }

  if (!values(WorkOpportunitiesTab).includes(tab)) {
    history.replace("/marketplace/work_opportunities");
    return null;
  }

  return tab;
};
